import React from "react";
import bg from "../../images/renaturer.png";
import img from "../../images/nature.png";

const GallyNaturelle = () => {
  return (
    <div>
      <section
        className="p-4 text-center sm:p-6 md:p-10 lg:p-20 bg-black/70 bg-blend-overlay"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-xl font-bold text-center text-white sm:text-2xl md:text-3xl">
          Renaturer le ruisseau
        </h1>
        <div className="flex justify-center mt-4 sm:mt-6">
          <p className="max-w-3xl text-base text-white">
            Vers un Ru de Gally Plus Naturel et Résilient
          </p>
        </div>
      </section>
      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-20 sm:px-6 lg:px-8">
        <h2 className="text-xl font-bold text-center text-black">
          Redonner une forme naturelle au ruisseau
        </h2>
        <div className="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <p className="text-base">
              Dès le Xe siècle,{" "}
              <span className="text-primary">le ru de Gally</span> a vu son
              tracé bouleversé dans le but de le rendre plus rectiligne afin de
              faciliter les travaux agricoles. Si elles étaient pratiques pour
              l’activité humaine, ces modifications ont perturbé l’écosystème du
              ruisseau. Outre une pollution accrue, cette chenalisation à
              outrance a augmenté les risques d’inondation.
            </p>
            <p className="mt-4 text-base">
              <span className="text-primary">HYDREAULYS</span> s’est donné pour
              objectif de redonner une forme naturelle au ru de Gally. Ce
              faisant, une plus grande biodiversité devrait pouvoir être
              observée. Les poissons, notamment, qui ont besoin d’habitats
              spécifiques pour se nourrir et se reproduire, pourront faire leur
              retour lorsque leur écosystème naturel sera restauré.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src={img}
              alt="Natural restoration of Ru de Gally"
              className="object-cover w-full h-auto max-w-xs rounded-lg sm:max-w-full"
            />
          </div>
        </div>
        <div className="flex flex-col justify-center gap-6 mt-6 sm:mt-20 md:flex-row">
          <div className="flex-1 p-4 text-center bg-white border border-gray-200 rounded-lg shadow-xl sm:p-6">
            <div className="mx-auto mb-4 text-2xl sm:text-3xl">🌿</div>
            <h3 className="mb-2 text-base font-semibold text-black">
              Restauration de l’écosystème
            </h3>
          </div>
          <div className="flex-1 p-4 text-center bg-white border border-gray-200 rounded-lg shadow-xl sm:p-6">
            <div className="mx-auto mb-4 text-2xl sm:text-3xl">🐟</div>
            <h3 className="mb-2 text-base font-semibold text-black">
              Retour de la biodiversité
            </h3>
            <p className="text-base text-neutral-400">
              (poissons et autres espèces)
            </p>
          </div>
          <div className="flex-1 p-4 text-center bg-white border border-gray-200 rounded-lg shadow-xl sm:p-6">
            <div className="mx-auto mb-4 text-2xl sm:text-3xl">💧</div>
            <h3 className="mb-2 text-base font-semibold text-black">
              Réduction du risque d’inondation
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GallyNaturelle;
